import React, { useLayoutEffect } from 'react';
import prismjs from 'prismjs';
import './prism.css';

const prettyPrint = n => {
  if ([true, false].includes(n)) {
    return `${n}`;
  }
  if (typeof n === 'number') {
    return n;
  }
  if (typeof n === 'string') {
    return `"${n}"`;
  }
  if (Array.isArray(n)) {
    return JSON.stringify(n);
  }

  return '?';
};

// eslint-disable-next-line react/prop-types
const SpectrumCode = ({ config }) => {
  useLayoutEffect(() => {
    prismjs.highlightAll();
  });

  return (
    <div className="generated-code">
      <pre>
        <code className="language-javascript">
          {`
import React from "react";
import Spectrum from "react-spectrum";

function Placeholder() {
  return (
    <Spectrum
      ${Object.keys(config).reduce((p, c) => {
        const current = `${c}={${prettyPrint(config[c])}}`;
        return p.length
          ? `${p}
      ${current}`
          : `${current}`;
      }, ``)}
    />
  );
}
          `}
        </code>
      </pre>
    </div>
  );
};

export default SpectrumCode;
